import React from 'react';
import '../App.css';

const Recognition = () => {
  return (

    <>
      <div className="achievements">
        <div className="category">
          <h4 className="category-title">Technical Achievements</h4>
          <ul className="custom-list"><span className="year">2024</span>
            <li> 🏆 Quine - <a href="https://quine.sh/user/aj1904" target="_blank" rel="noreferrer">Quest 008</a> - 4th position</li>
            <li> 🏆 Quine - <a href="https://quine.sh/user/aj1904" target="_blank" rel="noreferrer">Quest 011</a> - 7th position</li>
            <li> 🏆 Fun Challenge: Experience the Web3 with <a href="https://www.topcoder.com/challenges/65111bd4-8df9-4967-87ce-ace13c1435da" target="_blank" rel="noreferrer">Fujitsu Research Portal</a> </li>

          </ul>
          <ul className="custom-list"><span className="year">2023</span>
            <li> 🏆 Devlympics - <a href="https://www.linkedin.com/feed/update/urn:li:activity:7125636883652472833/" target="_blank" rel="noreferrer">The Ultimate Warrior</a> (Secure Code Warrior)</li>
            <li> 🏆 Devlympics - <a href="https://www.linkedin.com/feed/update/urn:li:activity:7125636883652472833/" target="_blank" rel="noreferrer">Web - 2nd Place</a> (Secure Code Warrior) </li>
            <li> 🏆 Devlympics - <a href="https://www.linkedin.com/feed/update/urn:li:activity:7125636883652472833/" target="_blank" rel="noreferrer">API - 2nd Place</a> (Secure Code Warrior) </li>
            <li> 🏆 Devlympics - <a href="https://www.linkedin.com/feed/update/urn:li:activity:7125636883652472833/" target="_blank" rel="noreferrer">Missions - 1st Place</a> (Secure Code Warrior) </li>
          </ul>
          <ul className="custom-list"><span className="year">2022</span>
            <li> 🏆 Devlympics Ultimate Warrior - Mobile - 1st Place (Secure Code Warrior) </li>
            <li> 🏆 Devlympics Ultimate Warrior - API - 3rd Place (Secure Code Warrior) </li>
            <li> 🏆 Devlympics Ultimate Warrior - Cloud - 3rd Place (Secure Code Warrior) </li>
            <li> 🏆 Amazon Ads - <a href="https://www.hackerearth.com/challenges/new/competitive/amazon-ads-womens-coding-challenge/" target="_blank" rel="noreferrer">Women's Coding Challenge</a> - Top 15 (HackerEarth)</li>
            <li> 🏆 1st Place Winner OSA Unite Capture The Flag Event - Intermediate </li>
          </ul>
          <ul className="custom-list"><span className="year">2021</span>
            <li> 🏆 1st Place Winner OSA Unite Capture The Flag Event - Intermediate</li>
            <li> 🏆 1st Place Winner OSA unite Capture The Flag Event - Novice</li>
          </ul>
          <ul className="custom-list"><span className="year">2020</span>
            <li> 🏆 1st Place Winner OSA unite Capture the Flag</li>
          </ul>
        </div>
        <div className="category">
          <h4 className="category-title">Professional Awards</h4>
          <ul className="custom-list"><span className="year">2022</span>
            <li> 🏆 Diamond Award August </li>
          </ul>
          <ul className="custom-list"><span className="year">2021</span>
            <li> 🏆 Performance Award H2  </li>
            <li> 🏆 Performance Award Q4  </li>
            <li> 🏆 H1 Performance Award </li>
            <li> 🏆 Innovation Award </li>
            <li> 🏆 Star Award </li>
            <li> 🏆 Collaboration Award </li>
            <li> 🏆 Game of Scrums 2nd place winner: Iconic Warriors </li>
          </ul>
          <ul className="custom-list"><span className="year">2020</span>
            <li> 🏆 Year End Performance Award </li>
            <li> 🏆 Sustaining Edge Award </li>
            <li> 🏆 H1 Performance Award </li>
            <li> 🏆 Mid-Term Performance Award </li>
            <li> 🏆 Quality Award - Maintaining Data Integrity </li>
            <li> 🏆 Performance Award - Q2 </li>
          </ul>
          <ul className="custom-list"><span className="year">2019</span>
            <li> 🏆 Star Award </li>
          </ul>
        </div>
        <div className="category">
          <h4 className="category-title">Other Awards</h4>

          <ul className="custom-list"><span className="year">2024</span>
            <li> 🏆 Aggie Voice: 2024 February Prize </li>
            <li> 🏆 Student Employee Of The Year 2024 Nomination</li>
          </ul>

          <ul className="custom-list"><span className="year">2023</span>
            <li> 🏆 Department of Computer Science and Engineering Scholarship 2023-24</li>
            <li> 🏆 Grace Hopper Celebration 2023 Scholarship</li>
            <li> 🏆 CS50x Puzzle Day: Highest score certificate 2023 from Cambridge Massachusetts </li>
            <li> 🏆 Github's Top Machine Learning Voice</li>
          </ul>
          <ul className="custom-list"><span className="year">Older</span>
            <li> 🏆 L&D Quiz Winner 2021</li>
            <li> 🏆 Live well - Walk from home - 1st Place 2021</li>
            <li> 🏆 IWD #herStory Winner 2021</li>
            <li> 🏆 L&D Quiz Winner 2020</li>
            <li> 🏆 NTSE Scholar 2013</li>
            <li> 🏆 Junior Science Olympiad 2012</li>
          </ul>
        </div>
      </div>

    </>
  );
};

export default Recognition;

